module.exports = __webpack_public_path__ + "img/death.ddc7d3b6.svg";